export default __webpack_public_path__ + "static/media/media01.67f647d7.jpg";